import { LGraphNode, LiteGraph } from "litegraph.js";
import { applyMirror } from "../engine/effects.js";

/**
 * MirrorNode
 * ----------
 * Mirrors the input canvas horizontally, vertically, into quad, or kaleidoscope.
 */
export class MirrorNode extends LGraphNode {
  constructor() {
    super();
    this.title = "Mirror";

    this.properties = {
      mode: "horizontal",
    };

    this.addInput("Canvas", "canvas");
    this.addOutput("Canvas", "canvas");

    this.addWidget("combo", "Mode", "horizontal", (val) => {
      this.properties.mode = val;
    }, { values: ["horizontal", "vertical", "quad", "kaleidoscope"] });

    this._outCanvas = document.createElement("canvas");
    this._outCtx = this._outCanvas.getContext("2d");

    this.size = [200, 60];
    this.mode = LiteGraph.ALWAYS;
    this.color = "#2a2a2a";
    this.bgcolor = "#333333";
  }

  onExecute() {
    const input = this.getInputData(0);
    if (!input) { this.setOutputData(0, null); return; }

    const w = input.width;
    const h = input.height;
    if (this._outCanvas.width !== w) this._outCanvas.width = w;
    if (this._outCanvas.height !== h) this._outCanvas.height = h;

    const ctx = this._outCtx;
    ctx.clearRect(0, 0, w, h);
    ctx.drawImage(input, 0, 0);

    applyMirror(ctx, w, h, { mode: this.properties.mode });

    this.setOutputData(0, this._outCanvas);
  }
}

LiteGraph.registerNodeType("effects/Mirror", MirrorNode);
